/* eslint-disable jsx-a11y/no-static-element-interactions */
import { BsPauseFill } from "react-icons/bs";
import { MdLiveTv } from "react-icons/md";
import { PiRadioLight } from "react-icons/pi";
import { useIsMobile } from "~/hook/use-mobile";
import { useFontStyle } from "~/hook/useFontStyle";
import useStopCurrentRunningVideoAudio from "~/hook/useStopCurrentRunningVideoAudio";
import { LiveData } from "~/interface/home/home";
import { removeAudioPlayerKeyFromSession } from "~/lib/helperFuncation/sessionStorageService";
import { getYoutubeVideoThumbnail } from "~/lib/helperFuncation/youtubeThumbnails";
import { addToCurrentAudio, changeIsAudioPlayState, changeIsPlayingState, removeQueue, setMediaTypeControl } from "~/lib/store/slice/audioSlice";
import { onPauseVideo, onPlayVideo } from "~/lib/store/slice/youtubePlayerSlice";
import { useAppDispatch, useAppSelector } from "~/lib/store/store";
import { cn } from "~/lib/utils";
import { ICON_ORANGE_COLOR, LIVE_TV, PLAY_PAUSE_ICON_COLOR } from "~/utils/constant";

interface LiveDataCardProps {
  data: LiveData;
  selectedTab: string;
  selectedMedia?: string;
  handleOnTVClick: (type: string) => void;
}

function LiveDataCard({ data, selectedTab, selectedMedia, handleOnTVClick }: LiveDataCardProps) {
  const { currentAudio, isPlaying } = useAppSelector((state) => state.nityNiyam);
  const isMobile = useIsMobile();
  const { isVideoPlay } = useAppSelector((state) => state.youtubeVideo);
  const dispatch = useAppDispatch();
  const { bold, medium } = useFontStyle();

  const { removeVideoPlay } = useStopCurrentRunningVideoAudio();

  const name = selectedTab === LIVE_TV ? data.tv_title : data.radio_title;
  const thumbnail = selectedTab === LIVE_TV ? getYoutubeVideoThumbnail(data.yt_id, "medium") : `./images/${data.type}.png`;
  const commonButtonClass = `cursor-pointer  bg-secondaryColor border border-borderPrimary rounded-full flex flex-row justify-center items-center gap-2 px-3 py-2 ${
    isMobile ? "w-[90px]" : " w-[50px] lg:w-[90px]"
  }`;
  const isTVActive = selectedMedia?.split("-").join("_") === data.type && isVideoPlay;
  const isRadioActive = currentAudio?.from === "live" && currentAudio.id === data.id && isPlaying;

  const handleClickOnTv = () => {
    handleOnTVClick(data.type);
    dispatch(onPlayVideo(data.yt_id));
    dispatch(changeIsAudioPlayState(false));
    dispatch(changeIsPlayingState(false));
    removeAudioPlayerKeyFromSession();
    handleRadioPauseButtonClick();
  };

  const handleOnRadioClick = () => {
    dispatch(onPauseVideo());
    removeVideoPlay();

    const currentAudio = {
      id: data.id,
      img: null,
      totalDuration: null,
      artist: null,
      name: data.radio_title,
      audio: data.radio_url,
      from: "live",
      isLive: true,
    };

    dispatch(changeIsAudioPlayState(true));
    dispatch(changeIsPlayingState(true));
    dispatch(addToCurrentAudio(currentAudio));
    dispatch(removeQueue());
    setMediaTypeControl("music");
  };

  const handleRadioPauseButtonClick = () => {
    dispatch(changeIsPlayingState(false));
  };

  return (
    <div className="w-full">
      <div
        className="w-full bg-secondaryBackground pb-[10px] flex flex-col justify-start items-center  gap-1 md:gap-2 cursor-pointer rounded-xl overflow-hidden "
        title={name}
        onMouseDown={() => handleClickOnTv()}
      >
        <div className="w-full aspect-[16/9] overflow-hidden">
          <img src={thumbnail} alt={data.type ?? "Live TV Thumbnail"} className="w-full h-full object-cover bg-gray-200 select-none" />
        </div>
        <div className="w-full flex flex-col justify-center items-center px-3">
          <span className={cn("line-clamp-1 leading-8 text-textColor body_text_s capitalize w-full text-center", medium)}>{name}</span>
        </div>
        <div className="flex justify-center items-center gap-3 sm:gap-2">
          <div
            className={commonButtonClass}
            onMouseDown={(e) => {
              e.stopPropagation();
              e.preventDefault();
              isTVActive ? dispatch(onPauseVideo()) : handleClickOnTv();
            }}
            title={`Play ${data.tv_title}`}
          >
            <span> {isTVActive ? <BsPauseFill size={18} color={ICON_ORANGE_COLOR} /> : <MdLiveTv size={20} color={PLAY_PAUSE_ICON_COLOR} />}</span>
            <span className={cn("text-textColor body_text_s pt-px", isMobile ? "" : "hidden lg:block", medium)}>TV</span>
          </div>

          {data.radio_url && (
            <div
              className={commonButtonClass}
              onMouseDown={(e) => {
                e.stopPropagation();
                e.preventDefault();
                isRadioActive ? handleRadioPauseButtonClick() : handleOnRadioClick();
              }}
              title={`Play ${data.radio_title}`}
            >
              <span>
                {isRadioActive ? <BsPauseFill size={18} color={ICON_ORANGE_COLOR} /> : <PiRadioLight size={20} color={PLAY_PAUSE_ICON_COLOR} />}
              </span>
              <span className={cn("text-textColor body_text_s pt-px ", isMobile ? "" : "hidden lg:block", medium)}>Radio</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LiveDataCard;
